import axios from "axios";
import { ApiServices } from "../service/apiServices";

export const getClvHighestRevenueByTopUp = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvHighestRevenueByTopUp');
    return result;
};


export const getClvAnalysisTopCountByHours = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvAnalysisTopCountByHours');
    return result;
};

export const getClvAnalysisTopCountsWeekday = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvAnalysisTopCountsWeekday');
    return result;
};

export const getClvAnalysisTopAmountByHours = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvAnalysisTopAmountByHours');
    return result;
};

export const getClvAnalysisHighestRevenueByBundle = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvAnalysisHighestRevenueByBundle');
    return result;
};

export const getClvAnalysisBundleCountWeeday = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvAnalysisBundleCountWeeday');
    return result;
};

export const getClvAnalysisBundleCountByHours = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvAnalysisBundleCountByHours');
    return result;
};

export const getClvAnalysisBundleAmountByHours = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getClvAnalysisBundleAmountByHours');
    return result;
};

export const getSegementationTargetExperience = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getSegementationTargetExperience');
    return result;
};

export const getSegementationBasedOnCustomer = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getSegementationBasedOnCustomer');
    return result;
};

export const getSegementationDistributionChart = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getSegementationDistributionChart');
    return result;
};

export const getChurnPredictionSegmentRlt = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getChurnPredictionSegmentRlt');
    return result;
};


export const getChurnPredictionProbability = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getChurnPredictionProbability');
    return result;
};

export const getChurnPredictionOverallRlt = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getChurnPredictionOverallRlt');
    return result;
};

export const getRecommentationDtl = async (body: { fromYear: string | null; toYear: string | null; domainId: string | null }) => {
    const result = await ApiServices.post(body, '/getRecommentationDtl');
    return result;
};

export const clvSummaryNlpData = async () => {
    const response = await axios.get(
      "https://nlpcampaign.worktual.co.uk/plot_summary_clv_analysis_vectone"
    );
    return response;
  };

  export const segmentationNlpDatas = async () => {
    const response = await axios.get(
      "https://nlpcampaign.worktual.co.uk/segmentation_summary_vectone "
    );
    return response;
  };

  export const buyerPersonNlpData = async () => {
    const response = await axios.get(
      "https://nlpcampaign.worktual.co.uk/buyer_personna_summary_vectone"
    );
    return response;
  };

  
  export const churnPredictionNlpData = async () => {
    const response = await axios.get(
      "https://nlpcampaign.worktual.co.uk/churn_prediction_summary_vectone"
    );
    return response;
  };

export const sendToNlpCSVFile = async (file: any) => {
    const response = await axios.post('https://nlp.worktual.co.uk/store_files', file, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response;
}